//====================================================
//  Function: Reposition Detail
// - preusporiadanie prvkov v detaile produktu
// - preusporiadanie hlavičky, popisu, podobných a suvisiacich produktov
//====================================================

var detailHeader;
var detailInfo;
var detailHeaderInner;
var detailImageWrapper;
var detailInfoWrapper;

function componentsRepositionDetail() {
  if ($(".type-detail").length) {
    detailHeader = $(".p-detail-inner");
    detailInfo = $(".p-detail-info");
    detailHeaderInner = $(".p-detail-inner-header");
    detailImageWrapper = $(".product-top > .p-image-wrapper");
    detailInfoWrapper = $(".product-top > .p-info-wrapper");

    // change link for add-to-cart for Mix - sheet
    if (shopName === 'wsk' || shopName === 'whu') {
      disableSheetMixPurchase();
    }
    // add link to twin product on wsk - only pos
    if (shopName === 'pos') {
      externalLinkingToWsk();
    }
    // add show video button
    addYoutubeVideoButton();

    // reposition detail info
    repositionDetailHeader();

    // reposition detail description
    repositionDetailDescription();

    // visual changes in short description only for jam, mee and dpc
    if (shopName === 'jam' || shopName === 'mee' || shopName === 'dpc') {
      shortDescriptionSpecificVisualChanges();
    }

    // UPOZORNENIE: VŽDY MÔŽE BYŤ VIDITEĽNÝ LEN JEDEN Z BANNEROV!
    // add banner - eshop of the year only for wsk and wcz shopname
    if (shopName === 'wcz' || shopName === 'wro' || shopName === 'wsi' || shopName === 'whr') {
      addBannerEshopOfYear();
    }
    // add banner promotions
    if (shopName === 'wsk' || shopName === 'whu') {
      addBannerPromotions();
    }

    // rename related files to guides
    renameGuides();

    // reposition detail alternative products
    repositionDetailAlternativeProducts();

    // add product variants
    automaticRenderingVariants();

    if(
      $('.p-detail-tabs-wrapper #description .detail-parameters .row-header-label:contains("Nadrozmer")').length
      || $('.p-detail-tabs-wrapper #description .detail-parameters .row-header-label:contains("Túlméretes")').length
      //|| $('.p-detail-tabs-wrapper #description .detail-parameters .row-header-label:contains("Nadrozměr")').length
    ) {
      // add banner with notice about need for assistance in unloading goods
      assistanceInUnloadingGoods();
    }

    if($('#product-detail-form .p-info-wrapper').length) {
      // show expected date delivery if specific status is present
      checkStockStatusToShowExpectedDate();
      // highlight watchdog if product is unavailable
      highlightWatchDog();
      // attach term "delivery" to text about delivery
      prependStockStatusText();

      if($('#product-detail-form .p-info-wrapper .variant-list').length) {
          document.addEventListener('ShoptetVariantAvailable', function () {
              checkStockStatusToShowExpectedDate();
              highlightWatchDog();
          });
      }
    }
    if($('.products.products-block.products-related.products-additional.p-switchable').length){
      if (window.matchMedia('(max-width: ' + bpMedium + 'px)').matches) {
        // modify related products to slider on mobile and tablet devices
        relatedProductsSliderSmallDevices();
      }
    }
  }
}

function addYoutubeVideoButton() {
  if($('.p-detail-tabs-wrapper #description iframe[src*="youtube.com"]').length) {
    var buttonText;
    switch(lang) {
      case 'sk':
        buttonText = 'Zobraziť video';
        break;
      case 'hu':
        buttonText = 'Videó megjelenítése';
        break;
      case 'cs':
        buttonText = 'Zobrazit video';
        break;
      case 'ro':
        buttonText = 'Afișați video';
        break;
      case 'bg':
        buttonText = 'Zobraziť video';
        break;
      case 'hr':
        buttonText = 'Prikaži video';
        break;
      case 'si':
        buttonText = 'Prikazati videoposnetek';
        break;
      case 'ua':
        buttonText = 'Zobraziť video';
        break;
      default:
        return;
    }
    var videoElement = $('.p-detail-tabs-wrapper #description iframe[src*="youtube.com"]:first');
    $(detailInfo).append('<a href="#" class="w-youtube-play-btn">' + buttonText + '</a>')
    $('body').on('click', '.w-youtube-play-btn', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: videoElement.offset().top-60
        }, 500);
    });
  }
}

function repositionDetailHeader() {
  var fullDescriptionTerm;
  switch(lang) {
    case 'sk':
      fullDescriptionTerm = 'Celý popis';
      break;
    case 'hu':
      fullDescriptionTerm = 'Teljes leírás';
      break;
    case 'cs':
      fullDescriptionTerm = 'Celý popis';
      break;
    case 'ro':
      fullDescriptionTerm = 'Descriere completă';
      break;
    case 'bg':
      fullDescriptionTerm = 'Celý popis';
      break;
    case 'hr':
      fullDescriptionTerm = 'Cijeli opis';
      break;
    case 'si':
      fullDescriptionTerm = 'Celoten opis';
      break;
    case 'ua':
      fullDescriptionTerm = 'Celý popis';
      break;
    default:
      return;
  }
  // reposition product description
  detailInfoWrapper
    .find(".p-short-description, .p-short-description + p")
    .wrapAll('<div class="p-short-description-block"></div>');

  detailInfoWrapper.find(".chevron-down-after").text(fullDescriptionTerm);

  removeDetailInfoLinks();

  addDetailInfoLinks();

  addTopInfoBlock();

  freeDeliveryBlock();

  // setTimeout(() => {
  // 	if ($('.p-short-description-block .chevron-after[href="#description"]').length == 0) {
  // 		$('.p-short-description-block').append(detailInfoWrapper.find('.chevron-after[href="#description"]').closest('p'));
  // 	}
  // }, 1000);
}

function freeDeliveryBlock() {
  var freeShippingTerm;
  switch(lang) {
    case 'sk':
      freeShippingTerm = 'Doprava Zadarmo';
      break;
    case 'hu':
      freeShippingTerm = 'Ingyenes Szállítás';
      break;
    case 'cs':
      freeShippingTerm = 'Doprava Zdarma';
      break;
    case 'ro':
      freeShippingTerm = 'Transport Gratuit';
      break;
    case 'bg':
      freeShippingTerm = 'Doprava Zadarmo';
      break;
    case 'hr':
      freeShippingTerm = 'Besplatna Dostava';
      break;
    case 'si':
      freeShippingTerm = 'Brezplačna dostava';
      break;
    case 'ua':
      freeShippingTerm = 'Doprava Zadarmo';
      break;
    default:
      return;
  }
  if (detailImageWrapper.find(".flag-freeshipping").length) {
    $(".p-info-wrapper-content .p-final-price-wrapper").append(
      detailImageWrapper.find(".flag-freeshipping")
    );
    $(".p-info-wrapper-content .flag-freeshipping .flag-text").text(freeShippingTerm);
  }
}

function removeDetailInfoLinks() {
  $(".link-icon.share, .link-icon.print ").remove();
}

function addDetailInfoLinks() {
  var socialBlock = $(".link-icons");
  var article;
  var articleLink;
  var questionChatText;
  var watchDogLinkText;
  var transport;
  var faq;

  switch(lang) {
    case 'sk':
      watchDogLinkText = '<span>Poslať upozornenie,</span><small>keď sa zmení dostupnosť produktu.</small>';
      questionChatText = '<span>Máte otázku?</span><small>Napíšte nám a naši špecialisti vám radi pomôžu.</small>';
      break;
    case 'hu':
      watchDogLinkText = '<span>Küldjön figyelmeztetést,</span><small>amennyiben változik a termék elérhetősége.</small>';
      questionChatText = '<span>Kérdésed van?</span><small>Írj nekünk és a specialistáink szívesen segítenek.</small>';
      break;
    case 'cs':
      watchDogLinkText = '<span>Odeslat upozornění,</span><small>když se změní dostupnost produktu.</small>';
      questionChatText = '<span>Máte dotaz?</span><small>Napište nám a naši specialisté vám rádi pomohou.</small>';
      break;
    case 'ro':
      watchDogLinkText = '<span>Trimitere notificare</span><small> când produsul devine disponibil.</small>';
      questionChatText = '<span>Aveți o întrebare?</span><small>Scrieți-ne și specialiștii noștri vă vor ajuta cu plăcere.</small>';
      break;
    case 'bg':
      watchDogLinkText = '<span>Poslať upozornenie </span><small>kada se promijeni dostupnost proizvoda.</small>';
      questionChatText = '<span>Máte otázku?</span><small>Napíšte nám a naši špecialisti vám radi pomôžu.</small>';
      break;
    case 'hr':
      watchDogLinkText = '<span>Poslati obavijest</span><small> kada se promijeni dostupnost proizvoda.</small>';
      questionChatText = '<span>Imate pitanje?</span><small>Pišite nam i naši stručnjaci će vam rado pomoći.</small>';
      break;
    case 'si':
      watchDogLinkText = '<span>Poslati opozorilo, </span><small>ko se razpoložljivost izdelka spremeni.</small>';
      questionChatText = '<span>Imate vprašanje?</span><small> Kontaktirajte nas in naši strokovnjaki vam bodo z veseljem pomagali.</small>';
      break;
    case 'ua':
      watchDogLinkText = '<span>Poslať upozornenie,</span><small>keď sa zmení dostupnosť produktu.</small>';
      questionChatText = '<span>Máte otázku?</span><small>Napíšte nám a naši špecialisti vám radi pomôžu.</small>';
      break;
    default:
      return;
  }
  switch(shopName) {
    case 'wsk':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/ako-si-vybrat-ten-spravny-matrac--poradime-vam/',
            title: 'Ako vybrať správny matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/ako-vybrat-rost-do-postele/',
            title: 'Ako vybrať rošt na posteľ?'
        }
      };
      transport = {
        link: '/vsetko-o-nakupe/',
        title: 'Všetko o nákupe na Wilsondo.sk',
        text: '(doprava a platba, výnos tovaru, recenzie, reklamácie).'
      };
      faq = {
        link: '/faq-najcastejsie-otazky/',
        title: 'Najčastejšie otázky našich zákazníkov'
      };
      break;
    case 'whu':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/hasznos-tanacsok-matracvalasztassal-kapcsolatban/',
            title: 'Hogyan válasszunk matracot?'
        },
        childrenMattress: {
            searchTerm: 'Gyerekmatrac',
            link: '/blog/hogyan-valasszam-ki-a-megfelelo-gyerekmatracot/',
            title: 'Hogyan válasszunk gyerekmatracot?'
        },
        bedFrame: {
            searchTerm: 'Ágyrács',
            link: '/blog/milyen-agyracsot-vegyek/',
            title: 'Hogyan válasszam ki a megfelelő ágyrácsot?'
        }
      };
      transport = {
        link: '/vasarlasi-informaciok/',
        title: 'Vásárlással kapcsolatos információk a Wilsondo.hu',
        text: ' -n (szállítás, fizetés, lakásba szállítás, reklamáció, elégedett vásárlók).'
      };
      faq = {
        link: '/gyik-gyakran-ismetlodo-kerdesek/',
        title: 'Gyakran ismételt kérdések'
      };
      break;
    case 'wcz':
      article = {
        mattress: {
            searchTerm: 'Matrace',
            link: '/blog/jak-si-vybrat-tu-spravnou-matraci-poradime-vam/',
            title: 'Jak vybrat správnou matraci?'
        },
        childrenMattress: {
            searchTerm: 'Dětské matrac',
            link: '/blog/nevite-vybrat-spravnou-detskou-matraci-pomuzeme-vam/',
            title: 'Jak vybrat správnou dětskou matraci?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/jak-vybrat-rost-na-postel/',
            title: 'Jak vybrat rošt na postel?'
        }
      };
      transport = {
        link: '/vse-o-nakupu/',
        title: 'Vše o nákupu na Wilsondo.cz',
        text: '(doprava a platba, vrácení zboží, recenze, reklamace).'
      };
      faq = {
        link: '/faq-nejcastejsi-dotazy/',
        title: 'Nejčastější dotazy našich zákazníků'
      };
      break;
      //TODO WRO: po preklade kategórií a blogov doplniť správne URL
      case 'wro':
      article = {
        mattress: {
            searchTerm: 'Saltele',
            link: '/blog/cum-sa-alegeti-salteaua-potrivita-noi-va-vom-sfatui/',
            title: 'Cum să alegeți salteaua potrivită?'
        },
        childrenMattress: {
            searchTerm: 'Detsky matrac - Doplnit ked budeme mat preklad clanku',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Cum să alegeți salteaua pentru copii?'
        },
        bedFrame: {
            searchTerm: 'Paturi',
            link: '/blog/cum-sa-alegeti-o-somiera-de-pat/',
            title: 'Cum să alegeți o somieră de pat?'
        }
      };
      transport = {
        link: '/totul-despre-cumparaturi/',
        title: 'Totul despre cumpărăturile pe Wilsondo.ro',
        text: '(transport și plată, aducerea produselor, recenzii, reclamații).'
      };
      faq = {
        link: '/faq-cele-mai-frecvente-intrebari/',
        title: 'Întrebări frecvente ale clienților noștri'
      };
      break;
    case 'wbg':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/ako-si-vybrat-ten-spravny-matrac--poradime-vam/',
            title: 'Ako vybrať správny matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/ako-vybrat-rost-do-postele/',
            title: 'Ako vybrať rošt na posteľ?'
        }
      };
      transport = {
        link: '/vsetko-o-nakupe/',
        title: 'Všetko o nákupe na Wilsondo.sk',
        text: '(doprava a platba, výnos tovaru, recenzie, reklamácie).'
      };
      faq = {
        link: '/faq-najcastejsie-otazky/',
        title: 'Najčastejšie otázky našich zákazníkov'
      };
      break;
    case 'whr':
      article = {
        mattress: {
            searchTerm: 'TODO Matrac',
            link: '/blog/ako-si-vybrat-ten-spravny-matrac--poradime-vam/',
            title: 'Kako odabrati pravi madrac?'
        },
        childrenMattress: {
            searchTerm: 'TODO Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Kako odabrati dječji madrac?'
        },
        bedFrame: {
            searchTerm: 'TODO Rošt',
            link: '/blog/ako-vybrat-rost-do-postele/',
            title: 'Kako odabrati podnicu za krevet?'
        }
      };
      transport = {
        link: '/sve-o-kupnji/',
        title: 'Sve o kupovini na Wilsondo.hr',
        text: '(dostava i plaćanje, povrat robe, recenzije, reklamacije).'
      };
      faq = {
        link: '/faq-najcesca-pitanja/',
        title: 'Najčešća pitanja naših kupaca'
      };
      break;
    case 'wsi': //TODO HR/SI
      article = {
        mattress: {
            searchTerm: 'TODO Matrac',
            link: '/blog/ako-si-vybrat-ten-spravny-matrac--poradime-vam/',
            title: 'Kako izbrati pravo vzmetnico?'
        },
        childrenMattress: {
            searchTerm: 'TODO Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Kako izbrati otroško vzmetnico?'
        },
        bedFrame: {
            searchTerm: 'TODO Rošt',
            link: '/blog/ako-vybrat-rost-do-postele/',
            title: 'Kako izbrati posteljno dno?'
        }
      };
      transport = {
        link: '/vse-o-nakupovanju/',
        title: 'Vse o nakupovanju na Wilsondo.si',
        text: '(dostava in plačilo, pomoč pri natovarjanju/raztovarjanju, mnenja, reklamacije).'
      };
      faq = {
        link: '/pogosta-vprasanja/',
        title: 'Pogosto zastavljena vprašanja naših strank'
      };
      break;
    case 'wua':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/ako-si-vybrat-ten-spravny-matrac--poradime-vam/',
            title: 'Ako vybrať správny matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/ako-vybrat-rost-do-postele/',
            title: 'Ako vybrať rošt na posteľ?'
        }
      };
      transport = {
        link: '/vsetko-o-nakupe/',
        title: 'Všetko o nákupe na Wilsondo.sk',
        text: '(doprava a platba, výnos tovaru, recenzie, reklamácie).'
      };
      faq = {
        link: '/faq-najcastejsie-otazky/',
        title: 'Najčastejšie otázky našich zákazníkov'
      };
      break;
    //testovaci e-shop
    case 'test':
      article = {
        mattress: {
            searchTerm: 'Matrace',
            link: '/blog/jak-si-vybrat-tu-spravnou-matraci-poradime-vam/',
            title: 'Jak vybrat správnou matraci?'
        },
        childrenMattress: {
            searchTerm: 'Dětské matrac',
            link: '/blog/nevite-vybrat-spravnou-detskou-matraci-pomuzeme-vam/',
            title: 'Jak vybrat správnou dětskou matraci?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/jak-vybrat-rost-na-postel/',
            title: 'Jak vybrat rošt na postel?'
        }
      };
      transport = {
        link: '/vse-o-nakupu/',
        title: 'Vše o nákupu na Wilsondo.cz',
        text: '(doprava a platba, vrácení zboží, recenze, reklamace).'
      };
      faq = {
        link: '/faq-nejcastejsi-dotazy/',
        title: 'Nejčastější dotazy našich zákazníků'
      };
      break;
    case 'dpc':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/ako-vybrat-spravny-matrac/',
            title: 'Ako vybrať matrac? Naše tipy'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/neviete-vybrat-spravny-detsky-matrac--pomozeme-vam-pri-jeho-vybere/',
            title: 'Ako vybrať najlepší matrac pre dieťa?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/blog/aky-rost-je-vhodny-pod-vas-matrac--a-potrebujete-ho-vobec/',
            title: 'Ako vybrať správny rošt? Naše tipy'
        }
      };
      transport = {
        link: '/doprava-a-platba/',
        title: 'Viac o nákupe na Detskapostel.com',
        text: '(dôležité informácie o cene dopravy, platbe, výnose tovaru).'
      };
      faq = {
        link: '/faq-caste-otazky-zakaznikov/',
        title: 'Odpovede na najčastejši otázky zákazníkov'
      };
      break;
    case 'mee':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/hogyan-valasszunk-matracot//hogyan-valasszunk-matracot/',
            title: 'Hogyan válasszunk matracot?'
        },
        childrenMattress: {
            searchTerm: 'Gyerekmatrac',
            link: '/magazin/hogyan-valasszunk-gyerekmatracot--tippek-a-gyermektippek-a-gyermek-eletkoratol-fugg--en/',
            title: 'Hogyan válasszunk gyerek matracot?'
        },
        bedFrame: {
            searchTerm: 'Ágyrács',
            link: '/magazin/milyen-agyracsot-valasszak-az-agyba/',
            title: 'Hogyan válasszak ágyrácsot az ágyba?'
        }
      };
      transport = {
        link: '/szallitas-fizetes/',
        title: 'Vásárlási információk a Matrac-es-en.hu oldalunkon',
        text: '(szállítási idő, szállítási díj, fizetési feltételek és lakásba szállítás).'
      };
      faq = {
        link: '/gyakran-ismetlodo-kerdesek--gyik/',
        title: 'GYIK - Gyakran ismétlődő kérdések'
      };
      break;
    case 'jam':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/ako-vybrat-matrac/',
            title: 'Ako vybrať matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/magazin/ako-vybrat-detsky-matrac--tipy-podla-veku-dietata/',
            title: 'Ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'Rošt',
            link: '/magazin/ako-si-vybrat-rosty-do-postele/',
            title: 'Ako si vybrať rošty do postele?'
        }
      };
      transport = {
        link: '/doprava--platba--vynos/',
        title: 'Informácie o nákupe na Ja-a-matrac.sk',
        text: '(doba dodania, cena dopravy, platby, osobný odber a výnosu tovaru).'
      };
      faq = {
        link: '/faq-najcastejsie-otazky-zakaznikov/',
        title: 'FAQ: Najčastejšie otázky zákazníkov'
      };
      break;
      case 'eag':
      article = {
        mattress: {
          searchTerm: 'Matrac',
          link: '/blog/milyen-matracot-vegyek/',
          title: 'Milyen matracot vegyek?'
        },
        childrenMattress: {
          searchTerm: 'Gyerekmatrac',
          link: '/blog/milyen-gyerek-matracot-vegyek/',
          title: 'Milyen gyerekmatracot vegyek?'
        },
        bedFrame: {
          searchTerm: 'Ágyrács',
          link: '/blog/milyen-a-megfelelo-agyracs-a-matracomhoz/',
          title: 'Milyen ágyrács a megfelelő a matracához? Mi segítünk választani!'
        }
      };
      transport = {
        link: '/szallitas-fizetes-felvitel/',
        title: 'Vásárlással kapcsolatos információk a Emeletes-agyak.hu',
        text: 'Szállítás, Fizetés, Lakásba szállítás'
      };
      faq = {
        link: '/gyakran-ismetlodo-kerdesek-gyik/',
        title: 'Gyakran ismétlődő kérdések'
      };
      break;
      case 'pos':
      article = {
        mattress: {
            searchTerm: 'Matrac',
            link: '/blog/ako-si-vybrat-spravny-matrac/',
            title: 'Poradíme vám, ako vybať matrac?'
        },
        childrenMattress: {
            searchTerm: 'Detské matrac',
            link: '/blog/ako-vybrat-detsky-matrac--poradime-vam/',
            title: 'Poradíme vám, ako vybrať detský matrac?'
        },
        bedFrame: {
            searchTerm: 'postele',
            link: '/blog/typy-posteli-vhodna-postel-do-kazdej-izby/',
            title: 'Ako si vybrať vhodnú posteľ?'
        }
      };
      transport = {
        link: 'https://www.wilsondo.sk/vsetko-o-nakupe/?utm_source=poschodovky&utm_medium=referral&utm_campaign=external_linking',
        title: 'Viac informácií o nákupe',
        text: '(doručenie, platba, doba dodania, výnos...)'
      };
      faq = {
        link: 'https://www.wilsondo.sk/faq-najcastejsie-otazky/?utm_source=poschodovky&utm_medium=referral&utm_campaign=external_linking',
        title: 'Časté otázky našich zákazníkov | FAQ'
      };
      break;
    default:
      return;
  }
  // Add dynamic blog article link
  if ($(detailInfoWrapper).length) {
      if (
        ($('[itemprop="itemListElement"]:last-child').prev('[itemprop="itemListElement"]').find('[itemprop="name"]').text().includes(article.mattress.searchTerm) &&
        !$('[itemprop="itemListElement"]:last-child').prevAll('[itemprop="itemListElement"]').eq(1).find('[itemprop="name"]').text().includes(article.childrenMattress.searchTerm)) ||
        ($('[itemprop="itemListElement"]:last-child').prevAll('[itemprop="itemListElement"]').eq(1).find('[itemprop="name"]').text().includes(article.mattress.searchTerm) &&
        !$('[itemprop="itemListElement"]:last-child').prev('[itemprop="itemListElement"]').find('[itemprop="name"]').text().includes(article.childrenMattress.searchTerm))
        )
      {
        articleLink = '<a href="' + article.mattress.link + '" target="_blank" class="link-icon article-help-info" title="' + article.mattress.title + '"><span>' + article.mattress.title + '</span></a>';
      } else if (
        $('[itemprop="itemListElement"]:last-child').prev('[itemprop="itemListElement"]').find('[itemprop="name"]').text().includes(article.childrenMattress.searchTerm) ||
        $('[itemprop="itemListElement"]:last-child').prevAll('[itemprop="itemListElement"]').eq(1).find('[itemprop="name"]').text().includes(article.childrenMattress.searchTerm)
        )
      {
        articleLink = '<a href="' + article.childrenMattress.link + '" target="_blank" class="link-icon article-help-info" title="' + article.childrenMattress.title + '"><span>' + article.childrenMattress.title + '</span></a>';
      } else if (
        $('[itemprop="itemListElement"]:last-child').prev('[itemprop="itemListElement"]').find('[itemprop="name"]').text().includes(article.bedFrame.searchTerm) ||
        $('[itemprop="itemListElement"]:last-child').prevAll('[itemprop="itemListElement"]').eq(1).find('[itemprop="name"]').text().includes(article.bedFrame.searchTerm)
        )
      {
        articleLink = '<a href="' + article.bedFrame.link + '" target="_blank" class="link-icon article-help-info" title="' + article.bedFrame.title + '"><span>' + article.bedFrame.title + '</span></a>';
      }
  }
  // Link article - The article has to help customer with purchase
  socialBlock.prepend($(articleLink));

  // Link chat - Do you have question? - Customer can write to our support
  $(".link-icon.chat").html(questionChatText);

  // Link watchdog - Option to set alert that product is available
  $(".link-icon.watchdog").html(watchDogLinkText);

  // Link transport - All about shopping
  var transportLink = '<a href="'+ transport.link +'" class="link-icon transport" title="' + transport.title + '" rel="nofollow"><span>' + transport.title + '</span><small>' + transport.text + '</small></a>';
  socialBlock.append($(transportLink));

  // Link faq
  var faqLink = '<a href="' + faq.link + '" class="link-icon faq" title="' + faq.title + '" rel="nofollow"><span>' + faq.title + '.</span></a>';
  socialBlock.append($(faqLink));
}

function addTopInfoBlock() {
  detailInfoWrapper
    .find("> *:not(.p-short-description-block):not(.social-buttons-wrapper)")
    .wrapAll('<div class="p-info-wrapper-content"></div>');

  detailImageWrapper.prepend(detailInfo);
  detailImageWrapper.prepend(detailHeaderInner);

  var mattressBasicParameters;
  switch(lang) {
    case 'sk':
      mattressBasicParameters = ['Tvrdosť:', 'Nosnosť:', 'Výška:'];
      break;
    case 'hu':
      mattressBasicParameters = ['Keménység:', 'Terhelhetőség:', 'Magasság:'];
      break;
    case 'cs':
      mattressBasicParameters = ['Tvrdost:', 'Nosnost:', 'Výška:'];
      break;
    //TODO WRO: určiť podľa toho ako urobíme preklad! musí to byť jednotné všade tie isté 3 slová + dvojbodka
    case 'ro':
      mattressBasicParameters = ['Duritate:', 'Capacitate:', 'Înălțime:'];
      break;
    case 'bg':
      mattressBasicParameters = ['Tvrdosť:', 'Nosnosť:', 'Výška:'];
      break;
    case 'hr':
      mattressBasicParameters = ['Tvrdoća:', 'Nosivost:', 'Visina:'];
      break;
    case 'si':
      mattressBasicParameters = ['Trdota:', 'Nosilnost:', 'Višina:'];
      break;
    case 'ua':
      mattressBasicParameters = ['Tvrdosť:', 'Nosnosť:', 'Výška:'];
      break;
    default:
      return;
  }
  //add class 'mattress-basic-parameters' if does not exists
  $.each(mattressBasicParameters, function(index, mattressBasicParameter) {
    var mattressParameterParagraph = $('.p-info-wrapper .p-short-description p:has(strong:contains("' + mattressBasicParameter + '"))');

    //check if p already has class 'mattress-basic-parameters', apply only if it does not
    if (mattressParameterParagraph.length > 0 && !mattressParameterParagraph.hasClass('mattress-basic-parameters')) {
      mattressParameterParagraph.addClass('mattress-basic-parameters');
    }
  });

  // basic parameters for mattresses
  if ($(".mattress-basic-parameters").length) {
    $(".p-info-wrapper .mattress-basic-parameters").wrapAll(
      '<div class="mattress-basic-parameters-block"></div>'
    );
    $(".mattress-basic-parameters-block").insertAfter(
      ".p-info-wrapper-content .add-to-cart"
    );
  }

  // basic parameters for wardrobes
  if ($(".wardrobe-basic-parameters").length) {
    $(".p-info-wrapper .wardrobe-basic-parameters").wrapAll(
      '<div class="wardrobe-basic-parameters-block"></div>'
    );
    $(".wardrobe-basic-parameters-block").insertAfter(
      ".p-info-wrapper-content .add-to-cart"
    );
  }
}

function repositionDetailDescription() {
  var ratingTerm;
  switch(lang) {
    case 'sk':
      ratingTerm = 'Hodnotenia';
      break;
    case 'hu':
      ratingTerm = 'Értékelések';
      break;
    case 'cs':
      ratingTerm = 'Hodnocení';
      break;
    case 'ro':
      ratingTerm = 'Evaluări';
      break;
    case 'bg':
      ratingTerm = 'Hodnotenia';
      break;
    case 'hr':
      ratingTerm = 'Ocjene';
      break;
    case 'si':
      ratingTerm = 'Mnenja';
      break;
    case 'ua':
      ratingTerm = 'Hodnotenia';
      break;
    default:
      return;
  }
  if ($('#ratingTab .rate-average').length) {
    $('#ratingTab').prepend('<h3>'+ ratingTerm + '</h3>');
  }
}

function renameGuides() {
  if ($('.p-detail-tabs-wrapper').length) {
    var relatedFiles;
    var guides;
    switch(lang) {
      case 'sk':
        relatedFiles = 'Súvisiace súbory';
        guides = 'Návody';
        break;
      case 'hu':
        relatedFiles = 'Kapcsolódó fájlok';
        guides = 'Szerelési útmutató';
        break;
      case 'cs':
        relatedFiles = 'Související soubory';
        guides = 'Návody';
        break;
      case 'ro':
        relatedFiles = 'Fişiere asociate';
        guides = 'Instrucțiuni';
        break;
      case 'bg':
        relatedFiles = 'Súvisiace súbory';
        guides = 'Návody';
        break;
      case 'hr':
        relatedFiles = 'Povezane datoteke';
        guides = 'Upute';
        break;
      case 'si':
        relatedFiles = 'Povezane datoteke';
        guides = 'Navodila za uporabo';
        break;
      case 'ua':
        relatedFiles = 'Súvisiace súbory';
        guides = 'Návody';
        break;
      default:
        return;
    }

    $('.p-detail-tabs-wrapper .shp-tab-link:contains("' + relatedFiles + '")').text(guides);
  }
  $('.shp-tabs-holder').show();
}
function repositionDetailAlternativeProducts() {
  if ($(".tab-pane#productsAlternative").length) {
    var productsAlternative = $(".tab-pane#productsAlternative");
    var alternativeProductTerm;
    switch(lang) {
      case 'sk':
        alternativeProductTerm = 'Podobné produkty';
        break;
      case 'hu':
        alternativeProductTerm = 'Hasonló termékek';
        break;
      case 'cs':
        alternativeProductTerm = 'Podobné produkty';
        break;
      case 'ro':
        alternativeProductTerm = 'Alternativ';
        break;
      case 'bg':
        alternativeProductTerm = 'Podobné produkty';
        break;
      case 'hr':
        alternativeProductTerm = 'Slični proizvodi';
        break;
      case 'si':
        alternativeProductTerm = 'Podobni izdelki';
        break;
      case 'ua':
        alternativeProductTerm = 'Podobné produkty';
        break;
      default:
        return;
    }
    productsAlternative.wrapInner(
      '<div class="products-alternative-block"></div>'
    );

    $(".products-alternative-block").insertAfter(".p-detail-tabs-wrapper");
    $('.shp-tab-link[href="#productsAlternative"]')
      .closest(".shp-tab")
      .remove();
    $(".products-alternative-block").prepend(
      '<h2 class="products-alternative-header">' + alternativeProductTerm + '</h2>'
    );
  }
}

function automaticRenderingVariants() {
  var firstDetailElement = $('.products-alternative-block').length;
  var secondDetailElement = $('.p-info-wrapper .availability-value').length;

  if (firstDetailElement && secondDetailElement) {
    var automaticVariantTerm;
    var dimensionTerm;
    var dimensionWardrobeTerm;
    var breadcrumbsCategoryTerm;
    var colorVariantTerm;

    switch (lang) {
      case 'sk':
        automaticVariantTerm = 'Prevedenie';
        dimensionTerm = 'Rozmer';
        dimensionWardrobeTerm = 'Šírka v cm';
        colorVariantTerm = 'Farba';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      case 'hu':
        automaticVariantTerm = 'Kivitel';
        dimensionTerm = 'Méret';
        dimensionWardrobeTerm = 'Szélesség cm-ben';
        colorVariantTerm = 'Szín';
        breadcrumbsCategoryTerm = 'MATRACOK';
        break;
      case 'cs':
        automaticVariantTerm = 'Provedení';
        dimensionTerm = 'Rozměr';
        dimensionWardrobeTerm = 'Šířka v cm';
        colorVariantTerm = 'Barva';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      case 'ro':
        automaticVariantTerm = 'Execuție';
        dimensionTerm = 'Dimensiuni';
        dimensionWardrobeTerm = 'Lățime în cm';
        colorVariantTerm = 'Culoare';
        breadcrumbsCategoryTerm = 'SALTELE';
        break;
      case 'bg':
        automaticVariantTerm = 'Prevedenie';
        dimensionTerm = 'Rozmer';
        dimensionWardrobeTerm = 'Šírka v cm';
        colorVariantTerm = 'Farba';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      case 'hr':
        automaticVariantTerm = 'Izvedba';
        dimensionTerm = 'Dimenzija';
        dimensionWardrobeTerm = 'Širina u cm';
        colorVariantTerm = 'Boja';
        breadcrumbsCategoryTerm = 'MADRAC';
        break;
      case 'si':
        automaticVariantTerm = 'Izvedba';
        dimensionTerm = 'Dimenzija';
        dimensionWardrobeTerm = 'Širina v cm';
        colorVariantTerm = 'Barva';
        breadcrumbsCategoryTerm = 'VZMETNICE';
        break;
      case 'ua':
        automaticVariantTerm = 'Prevedenie';
        dimensionTerm = 'Rozmer';
        dimensionWardrobeTerm = 'Šírka v cm';
        colorVariantTerm = 'Farba';
        breadcrumbsCategoryTerm = 'MATRACE';
        break;
      default:
        return;
    }

    $('.products-alternative-block a.image').clone().removeClass('image').addClass('automatic-variant-img').insertAfter('.p-info-wrapper .availability-value').wrapAll("<div class='wrapper-automatic-variants'></div>");
    $('.p-info-wrapper .wrapper-automatic-variants').hide();
    $('.automatic-variant-img img').each(function (index) {
      $(this).attr('src', $(this).attr('data-src'));
    });
    $('.p-main-image img').first().clone().prependTo('.wrapper-automatic-variants').wrap('<a href="#" class="automatic-variant-img first-automatic-variant-img"></a>');
    $('.wrapper-automatic-variants').prepend('<p class="automatic-variants-title">' + automaticVariantTerm + '</p>');
    $('a.automatic-variant-img').wrapAll('<div class="scroll-automatic-variants"></div>');
    $('.p-info-wrapper .wrapper-automatic-variants').show();

    // Check for the word "MATRACE" in #navigation-1 span
    if ($('#navigation-1 span').text().toUpperCase().includes(breadcrumbsCategoryTerm) || $('#navigation-2 span').text().toUpperCase().includes(breadcrumbsCategoryTerm)) {
      // Hide images in .automatic-variant-img img and .first-automatic-variant-img img
      $('.automatic-variant-img img, .first-automatic-variant-img img').hide();

      // Replace images with the dimension from the href attribute for each .automatic-variant-img
      $('.automatic-variant-img').each(function () {
        var href = $(this).attr('href');
        var dimensionMatch = href.match(/(\d+x\d+)/);

        if (dimensionMatch) {
          var dimension = dimensionMatch[0];
          $('.automatic-variants-title').text(dimensionTerm);
          $(this).append('<span class="dimension-text">' + dimension + '</span>');
        }
      });

      // Get the dimension from the current URL and insert it for .first-automatic-variant-img
      var currentUrl = window.location.href;
      var currentDimensionMatch = currentUrl.match(/(\d+x\d+)/);

      if (currentDimensionMatch) {
        var currentDimension = currentDimensionMatch[0];
        $('.automatic-variants-title').text(dimensionTerm);
        $('.first-automatic-variant-img').append('<span class="dimension-text-first">' + currentDimension + '</span>');
      }
    }

    // Creating automatic rendering variants if wardrobe-basic-parameters exists
    if ($('#product-detail-form .wardrobe-basic-parameters').length > 0) {
      // Hide images in .automatic-variant-img img and .first-automatic-variant-img img
      $('.automatic-variant-img img, .first-automatic-variant-img img').hide();

      // Replace images with the dimension from the href attribute for each .automatic-variant-img
      $('.automatic-variant-img').each(function () {
        var href = $(this).attr('href');
        var dimensionMatch = href.match(/(\d+)x/);

        if (dimensionMatch) {
          var dimension = dimensionMatch[1];
          $('.automatic-variants-title').text(dimensionWardrobeTerm);
          $(this).append('<span class="dimension-text">' + dimension + '</span>');
        }
      });

      // Get the dimension from the current URL and insert it for .first-automatic-variant-img
      var currentUrl = window.location.href;
      var currentDimensionMatch = currentUrl.match(/(\d+)x/);

      if (currentDimensionMatch) {
        var currentDimension = currentDimensionMatch[1];
        $('.automatic-variants-title').text(dimensionWardrobeTerm);
        $('.first-automatic-variant-img').append('<span class="dimension-text-first">' + currentDimension + '</span>');
      }
    }

    // Now we check if the dimension-text in automatic-variant-img is the same as in first-automatic-variant-img
    $('.automatic-variant-img').each(function () {
      var dimensionText = $(this).find('.dimension-text').text();
      var firstDimensionText = $('.first-automatic-variant-img .dimension-text-first').text();

      // If the dimension-text is the same, show the image instead of the dimension
      if (dimensionText === firstDimensionText) {
        $(this).find('img').show();  // Show the image
        $(this).find('.dimension-text').hide();  // Hide the dimension text
        $(this).addClass('with-image').removeClass('without-image');
      } else {
        $(this).find('img').hide();  // Hide the image
        $(this).find('.dimension-text').show();  // Show the dimension text
        $(this).addClass('without-image').removeClass('with-image');
      }
    });

    // Check if there are elements with images and also elements without images if they are we need 2 sliders
    var withImageElements = $('.automatic-variant-img.with-image');
    var withoutImageElements = $('.automatic-variant-img.without-image');
    var detailProductImage = $('.p-main-image img').first();

    if (withImageElements.length > 0 && withoutImageElements.length > 0) {
      // If there is at least one element with the class 'with-image'
      if (withImageElements.length > 0) {
        // Create a new wrapper with the class '.automatic-variants-color-wrap'
        var colorVariantsWrapper = $('<div class="automatic-variants-color-wrap"></div>');

        // Wrap the new wrapper in '.scroll-automatic-variants' to style the scroller
        var scrollWrapper = $('<div class="scroll-automatic-variants"></div>');
        scrollWrapper.append(colorVariantsWrapper);

        // For each found element with the class '.with-image', append it to the new wrapper
        withImageElements.each(function () {
          colorVariantsWrapper.append($(this));
        });

        // Clone main image and prepend it to the new wrapper
        var detailProductImage = detailProductImage.clone();
        detailProductImage.wrap('<a href="#" class="automatic-variant-img first-automatic-variant-img"></a>');
        colorVariantsWrapper.prepend(detailProductImage.parent());

        // Attach new scroller to main wrapper
        $('.wrapper-automatic-variants').prepend(scrollWrapper);

        // Add a heading
        colorVariantsWrapper.prepend('<p class="automatic-variants-title">' + colorVariantTerm + '</p>');
      }
    }
  }
}


function checkStockStatusToShowExpectedDate() {
  var validStockStatus;
  var deliveryTimeLabelTerm = $('.delivery-time-label').text();
  var currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label:visible').text().trim();
  switch (lang) {
    case 'sk':
      validStockStatus = [
        'Skladom',
        'Skladom | Doručíme do 48 hodín',
      ];
      break;
    case 'hu':
      validStockStatus = [
        'Raktáron',
        'Raktáron | 48 órán belül kézbesítjük',
        'Raktáron | 24 órán belül feladjuk',
      ];
      deliveryTimeLabelTerm = 'Legkésőbbi kézbesítési dátum:';
      break;
    case 'cs':
      validStockStatus = [
        'Skladem',
        'Skladem | Doručení do 48h',
        'Skladem | Odesíláme do 24h',
      ];
      break;
    case 'ro':
      validStockStatus = [
        'În stoc',
        'În stoc | Livrarăm în 48 de ore',
        'În stoc | Expediem în 24 de ore',
      ];
      break;
    case 'bg':
      validStockStatus = [
        'Skladom',
        'Skladom | Doručíme do 48 hodín',
      ];
      break;
    case 'hr':
      validStockStatus = [
        'Na stanju',
        'Na stanju | Šaljemo u roku od 24 sata',
      ];
      break;
    case 'si':
      validStockStatus = [
        'Na zalogi',
        'Na zalogi | Pošljemo v 24 urah',
      ];
      break;
    case 'ua':
      validStockStatus = [
        'Skladom',
        'Skladom | Doručíme do 48 hodín',
      ];
      break;
    default:
      return;
  }

  if(!currentStatus) {
    currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label').text().trim();
  }
  if(validStockStatus.indexOf(currentStatus) > -1) {
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time-label').addClass('active').text(deliveryTimeLabelTerm);
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time').addClass('active');
  } else {
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time-label').removeClass('active');
    $('#product-detail-form .p-info-wrapper .detail-parameters .delivery-time').removeClass('active');
  }
}

function assistanceInUnloadingGoods() {
  var hasBigproduct = false;
  var link = '/asistencia-pri-doruceni/';
  var altText = 'Potrebná asistencia pri vyložení produktu';
  var image;
  var version = 5;

  switch(lang) {
    case 'sk':
      link = '/asistencia-pri-doruceni/';
      altText = 'Potrebná asistencia pri vyložení produktu';
      break;
    case 'hu':
      link = '/kozremukodo-segitseg-kezbesiteskor/';
      altText = 'Szükséges asszisztencia a termék kipakolásánál';
      break;
    // TODO: skryté pretože výnos vieme poskytnúť len v prípade našej dopravy nie externých kuriérov
    //case 'cs':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potřebná asistence při vykládání produktu';
    //  break;
    //  case 'ro':
    //  link = '/asistencia-pri-doruceni/';
    //  altText = 'Este necesară asistență la descărcarea produsului';
    //  break;
    //case 'bg':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potřebná asistence při vykládání produktu';
    //  break;
    //case 'hr':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potrebna asistencija pri istovaru proizvoda';
    //  break;
    //case 'si':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Pri raztovarjanju izdelka je potrebna pomoč';
    //  break;
    //case 'ua':
    //  link = '/asistence-pri-doruceni/';
    //  altText = 'Potřebná asistence při vykládání produktu';
    //  break;
    default:
      return;
  }
  switch(shopName) {
    case 'wsk':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/nadrozmer_wsk.svg?v'+version;
      break;
    case 'whu':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/nadrozmer_whu.svg?v'+version;
      break;
    //case 'wcz':
    //  version = 1;
    //  image = 'https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/documents/Scripty/images/nadrozmer_2_cz.svg?v'+version;
    //  break;
    case 'dpc':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/dpc/nadrozmer_dpc.svg?v'+version;
      break;
    case 'mee':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/mee/nadrozmer_mee.svg?v'+version;
      break;
    case 'jam':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/jam/nadrozmer_jam.svg?v'+version;
      break;
    case 'eag':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/eag/nadrozmer_eag.svg?v'+version;
      break;
    case 'pos':
      version = 2;
      image = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/pos/nadrozmer_pos.svg?v'+version;
      break;
    default:
      return;
  }
  var html = '<div class="notice-w-2"><a href="'+link+'"><img src="'+image+'" alt="'+altText+'" /></a></div>';
  $(html).insertBefore('.p-short-description-block');
  hasBigproduct = true;
}

function highlightWatchDog() {
  var textStatus;
  switch(lang) {
    case 'sk':
      textStatus = 'Nedostupné';
      break;
    case 'hu':
      textStatus = 'Nem elérhető';
      break;
    case 'cs':
      textStatus = 'Momentálně nedostupné';
      break;
    case 'ro':
      textStatus = 'Nu este disponibil';
      break;
    case 'bg':
      textStatus = 'Nedostupné';
      break;
    case 'hr':
      textStatus = 'Nedostupno';
      break;
    case 'si':
      textStatus = 'Ni na voljo';
      break;
    case 'ua':
      textStatus = 'Nedostupné';
      break;
    default:
      return;
  }
  var currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label:visible').text().trim();
  if(!currentStatus) {
      currentStatus = $('#product-detail-form .p-info-wrapper .availability-value .availability-label').text().trim();
  }
  if(currentStatus == textStatus) {
      $('#product-detail-form .p-info-wrapper .link-icon.watchdog').addClass('highlighted');
  } else {
      $('#product-detail-form .p-info-wrapper .link-icon.watchdog').removeClass('highlighted');
  }
}

function relatedProductsSliderSmallDevices() {
  $('.products.products-block.products-related.products-additional.p-switchable')
    .addClass('related-products-small-devices-wrapper')
    .find('.product')
    .removeClass('col-sm-6 col-md-12 col-lg-6 active inactive related-sm-screen-hide related-sm-screen-show')
    .addClass('related-product-small-devices');
}

function prependStockStatusText() {
  var inStockText;
  var emptyVariantText;
  var prependText;

  switch(lang) {
    case 'sk':
      inStockText = 'skladom';
      emptyVariantText = 'zvoľte';
      prependText = 'Dodanie: ';
      break;
    case 'hu':
      inStockText = 'raktáron';
      emptyVariantText = 'kérjük';
      prependText = 'Szállítás: ';
      break;
    case 'cs':
      inStockText = 'skladem';
      emptyVariantText = 'zvolte';
      prependText = 'Dodání: ';
      break;
    case 'ro':
      inStockText = 'în stoc';
      emptyVariantText = 'alegeți';
      prependText = 'Livrare: ';
      break;
    case 'bg':
      inStockText = 'skladom';
      emptyVariantText = 'odaberite';
      prependText = 'Dodanie: ';
      break;
    case 'hr':
      inStockText = 'na stanju';
      emptyVariantText = 'odaberite';
      prependText = 'Dostava: ';
      break;
    case 'si':
      inStockText = 'na zalogi';
      emptyVariantText = 'izberite';
      prependText = 'Dostava: ';
      break;
    case 'ua':
      inStockText = 'skladom';
      emptyVariantText = 'zvoľte';
      prependText = 'Dodanie: ';
      break;
    default:
      return;
  }

  $('#product-detail-form .p-info-wrapper .availability-value .availability-label').each(function( index ) {
      if (
        $(this).text().toLowerCase().indexOf(inStockText) === -1 &&
        $(this).text().toLowerCase().indexOf(prependText.toLowerCase()) === -1 &&
        $(this).text().toLowerCase().indexOf(emptyVariantText.toLowerCase()) === -1
      ) {
          $(this).text(prependText + $(this).text());
      }
  });
}

function addBannerEshopOfYear() {
  switch(shopName) {
    case 'wsk':
      var eshopOfYearLink = "/hodnotenia-wilsondo/recenzie/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/eshop_of_year_wsk.svg?v1";
      break;
    case 'wcz':
      var eshopOfYearLink = "/recenze/wilsondo-recenze-a-zkusenosti-zakazniku/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/wcz-eshop_of_year.png?v2";
      break;
    case 'wro':
      var eshopOfYearLink = "/de-ce-sa-cumparati-de-la-noi/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/wro-eshop_of_year.png?v2";
      break;
    case 'wbg':
      var eshopOfYearLink = "/hodnotenia-wilsondo/recenzie/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/eshop_of_year_wsk.svg?v1";
      break;
    case 'whr':
      var eshopOfYearLink = "/recenzije-wilsondo/recenzije/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whr/whr-eshop_of_year.png?v1";
      break;
    case 'wsi':
      var eshopOfYearLink = "/wilsondo-mnenja/pregledi/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsi/wsi-eshop_of_year.png?v1";
      break;
    case 'wua':
      var eshopOfYearLink = "/hodnotenia-wilsondo/recenzie/";
      var eshopOfYearImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/eshop_of_year_wsk.svg?v1";
      break;
    default:
      return;
  }
  if ($(".social-buttons-wrapper").length) {
    var bannerEshopOfYear = '<div class="eshop-of-year"><a href="' + eshopOfYearLink + '"><img src="' + eshopOfYearImageUrl + '" alt="Shop roku 2023 - Finalista | Wilsondo.sk"></a></div>';
    $('.social-buttons-wrapper').before(bannerEshopOfYear);
  }
}

function addBannerPromotions() {
  var promotionUrl;
  var promotionImageUrl;
  var promotionImageAlt;
  switch(shopName) {
    case 'wsk':
      promotionUrl = "/akcie-zlavy/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/children-room-promotion-sk.jpg?v1";
      promotionImageAlt = "Akcie a zľavy | Wilsondo.sk";
    //  promotionUrl = "/vypredaj-skladov/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sale-detail-sk.png?v1";
    //  promotionImageAlt = "Tukálny výpredaj | Wilsondo.sk";
      break;
    case 'whu':
      promotionUrl = "/akciok-kedvezmenyek/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/children-room-promotion-hu.jpg?v1";
      promotionImageAlt = "Akciók és kedvezmények | Wilsondo.hu";
    //  promotionUrl = "/kiarusitas/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/sale-detail-hu.png?v1";
    //  promotionImageAlt = "Tukális kiárusítás | Wilsondo.hu";
      break;
    case 'wcz':
      promotionUrl = "/akce-slevy/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/promotions_end_wcz.jpg?v1";
      promotionImageAlt = "Akce a slevy | Wilsondo.cz";
    //  promotionUrl = "/vyprodej-skladu/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/sales-wcz.jpg?v1";
    //  promotionImageAlt = "Velký výprodej skladu | Wilsondo.cz";
      break;
    case 'wro':
      promotionUrl = "/reduceri/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/promotions_end_wro.jpg?v1";
      promotionImageAlt = "Reduceri | Wilsondo.ro";
    //  promotionUrl = "/vanzari-de-stoc/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/sales-wro.jpg?v1";
    //  promotionImageAlt = "Mare lichidare de stoc | Wilsondo.ro";
      break;
    case 'wbg':
      promotionUrl = "/akcie-zlavy/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/detske-postele-detske-postielky-akcia.jpg?v1";
      promotionImageAlt = "Akcie a zľavy | Wilsondo.sk";
    //  promotionUrl = "/vypredaj-skladov/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
    //  promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    case 'whr':
      promotionUrl = "/akcije-popusti/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/detske-postele-detske-postielky-akcia.jpg?v1";
      promotionImageAlt = "Akcije i popusti | Wilsondo.hr";
    //  promotionUrl = "/vypredaj-skladov/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
    //  promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    case 'wsi':
      promotionUrl = "/akcije-popusti/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/detske-postele-detske-postielky-akcia.jpg?v1";
      promotionImageAlt = "Akcije in popusti | Wilsondo.si";
    //  promotionUrl = "/vypredaj-skladov/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
    //  promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    case 'wua':
      promotionUrl = "/akcie-zlavy/";
      promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/detske-postele-detske-postielky-akcia.jpg?v1";
      promotionImageAlt = "Akcie a zľavy | Wilsondo.sk";
    //  promotionUrl = "/vypredaj-skladov/?order=bestseller";
    //  promotionImageUrl = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/sales-wsk.jpg?v1";
    //  promotionImageAlt = "Veľký výpredaj skladu | Wilsondo.sk";
      break;
    default:
      return;
  }
  if ($(".social-buttons-wrapper").length) {
    var bannerPromotion = '<div class="banner-promotion-detail"><a href="' + promotionUrl + '"><img src="' + promotionImageUrl + '" alt="' + promotionImageAlt + '"></a></div>';
    $('.type-detail .social-buttons-wrapper').before(bannerPromotion);
  }
}

function shortDescriptionSpecificVisualChanges() {
  $('.p-short-description-block p').addClass('visual-changes-jam-mee');
}

function externalLinkingToWsk() {
  var urlMapping = {
    "/latovy-rost-160x70--250kg/" : "/rost-latovy-160x70--250kg/",
    "/hugo-pred-vyvysena-postel-biela/" : "/vyvysena-postel-hugo-pred-biela/",
    "/veronika-7-200x90-postel-s-pristelkou-a-uloznym-priestorom-2/" : "/lpw-007-200-x-90/",
    "/paula-2-200x90-poschodova-postel-z-masivu/" : "/poschodova-postel-paula-2-200x90-prirodna/",
    "/troj-poschodova-postel-petra-5-180x80-2/" : "/lpt-005-poschodova-postel-s-pristelkou-180x80/",
    "/postel-poschodova-paula-7-180x80-2/" : "/poschodova-postel-lp-007-180x80/",
    "/poschodove-postele-pre-deti-paula-7-200x90-2/" : "/poschodova-postel-lp-007-200x90/",
    "/poschodova-postel-s-pristelkou-petra-2-200x90/" : "/lpt-002-200x90-poschodova-postel-s-pristelkou/",
    "/poschodova-postel-s-pristelkou-petra-1-200x90/" : "/lpt-001-200x90-poschodova-postel-s-pristelkou/",
    "/chranic-na-matrac-160x90/" : "/chranic-na-matrac-160x90-cm/",
    "/sada-uloznych-boxov-pre-postel-mix-diego-pred-biely/" : "/sada-uloznych-boxov-pre-postel-mix-diego-pred-biele/",
    "/penovy-matrac-pretoria-180x80-2/" : "/penovy-matrac-pretoria-180x80/",
    "/matrac-babmbino-console-kokos-pohanka-160x70/" : "/matrac-bambino-console-kokos-pohanka-160x70/",
    "/matrac-kokos-pohanka-bambino-console-160x80-2/" : "/matrac-kokos-pohanka-bambino-console-160x80/",
    "/obojstranny-detsky-matrac-bamino-console-180x80/" : "/obojstranny-detsky-matrac-bambino-console-180x80/",
    "/obojstranny-kokosovo-pohankovy-matrac-bambino-console-190x80/" : "/kokosovo-pohankovy-matrac-bambino-console-190x80/",
    "/vrchny-matrac-200x80-visco-8-cm-2/" : "/vrchny-matrac-200x80-visco-8-cm/",
    "/vrchny-matrac-visco-200x90-8-cm-2/" : "/vrchny-matrac-visco-200x90-8-cm/",
    "/vrchny-matrac-visco-200x100-8-cm-2/" : "/vrchny-matrac-visco-200x100-8-cm/",
    "/vrchny-matrac-visco-200x120-8-cm-2/" : "/vrchny-matrac-visco-200x120-8-cm/",
    "/vrchny-matrac-visco-200x140-8-cm-2/" : "/vrchny-matrac-visco-200x140-8-cm/",
    "/vrchny-matrac-visco-200x160-8-cm-2/" : "/vrchny-matrac-visco-200x160-8-cm/",
    "/vrchny-matrac-visco-200x180-8-cm-2/" : "/vrchny-matrac-visco-200x180-8-cm/",
    "/visco-vrchny-matrac-200x200-8-cm-2/" : "/visco-vrchny-matrac-200x200-8-cm/",
    "/vrchny-matrac-z-latexu-200x80-4-cm-2/" : "/vrchny-matrac-z-latexu-200x80-4-cm/",
    "/vrchny-latexovy-matrac-z-latexu-200x90-4-cm-2/" : "/vrchny-latexovy-matrac-z-latexu-200x90-4-cm/",
    "/pristelkovy-matrac-z-latexu-200x100-4-cm-2/" : "/pristelkovy-matrac-z-latexu-200x100-4-cm/",
    "/vrchny-latexovy-matrac-200x120-4-cm-2/" : "/vrchny-latexovy-matrac-200x120-4-cm/",
    "/latexovy-vrchny-matrac-200x140-4-cm-2/" : "/latexovy-vrchny-matrac-200x140-4-cm/",
    "/vrchny-latexovy-matrac-200x160-4-cm-2/" : "/vrchny-latexovy-matrac-200x160-4-cm/",
    "/latexovy-vrchny-matrac-200x180-4-cm-2/" : "/latexovy-vrchny-matrac-200x180-4-cm/",
    "/latexovy-vrchny-matrac-200x200-4-cm-2/" : "/latexovy-vrchny-matrac-200x200-4-cm/",
    "/vrchny-matrac-z-pamatovej-peny-visco-200x80-4-cm-2/" : "/vrchny-matrac-z-pamatovej-peny-visco-200x80-4-cm/",
    "/vrchny-penovy-matrac-200x90-4-cm-2/" : "/vrchny-penovy-matrac-200x90-4-cm/",
    "/vrchny-matrac-z-pamatovej-peny-visco-200x100-4-cm-2/" : "/vrchny-matrac-z-pamatovej-peny-visco-200x100-4-cm/",
    "/vrchny-matrac-z-visco-pamatovej-peny-200x120-4-cm-2/" : "/vrchny-matrac-z-visco-pamatovej-peny-200x120-4-cm/",
    "/ortopedicky-vrchny-matrac-200x140-4--cm-2/" : "/ortopedicky-vrchny-matrac-200x140-4--cm/",
    "/vrchny-matrac-200x160-4-cm-2/" : "/vrchny-matrac-200x160-4-cm/",
    "/pristelkovy-matrac-z-visco-peny-200x180-4-cm-2/" : "/pristelkovy-matrac-z-visco-peny-200x180-4-cm/",
    "/vrchny-penovy-matrac-z-visco-peny-200x200-4-cm-2/" : "/vrchny-penovy-matrac-z-visco-peny-200x200-4-cm/",
    "/vrchny-latexovy-matrac-200x80-2-cm-2/" : "/vrchny-latexovy-matrac-200x80-2-cm/",
    "/vrchny-latexovy-matrac-200x90-2-cm-2/" : "/vrchny-latexovy-matrac-200x90-2-cm/",
    "/latexovy-pristelkovy-matrac-200x100-2-cm-3/" : "/latexovy-pristelkovy-matrac-200x100-2-cm/",
    "/vrchny-matrac-z-latexu-200x120-2-cm-2/" : "/vrchny-matrac-z-latexu-200x120-2-cm/",
    "/vrchny-matrac-z-prirodneho-latexu-200x140-2-cm-2/" : "/vrchny-matrac-z-prirodneho-latexu-200x140-2-cm/",
    "/latexovy-vrchny-matrac-200x160-2-cm-2/" : "/latexovy-vrchny-matrac-200x160-2-cm/",
    "/latexovy-matrac-200x180-2-cm-2/" : "/latexovy-matrac-200x180-2-cm/",
    "/vrchny-matrac-z-latexu-200x200-2-cm-2/" : "/vrchny-matrac-z-latexu-200x200-2-cm/",
    "/matrac-pre-deti-adriana-160x80/" : "/detsky-matrac-adriana-160x80/",
    "/corela-matrac-s-latexom-a-hr-penou-180x80-2/" : "/corela-matrac-s-latexom-a-hr-penou-180x80/",
    "/priedusny-latexovy-matrac-s-hr-penou-180x90-corela-2/" : "/priedusny-latexovy-matrac-s-hr-penou-180x90-corela/",
    "/pevny-priedusny-latexovy-matrac-corela-190x90-2/" : "/pevny-priedusny-latexovy-matrac-corela-190x90/",
    "/priedusny-latexovy-matrac-corela-200x90-2/" : "/priedusny-latexovy-matrac-corela-200x90/",
    "/matrac-lugano-200x90-s-pamatovou-visco--lenivou--penou/" : "/matrac-lugano-200x90-s-pamatovou--lenivou--penou/",
    "/matrac-lujza-s-hr-penou-180x80-2/" : "/matrac-lujza-s-hr-penou-180x80/",
    "/lujza-matrac-z-polyuretanovej-peny-s-hr-penou-180x90/" : "/lujza-penovy-matrac-s-hr-penou-180x90/",
    "/pikolino-matrac-160x80-s-kokosom-2/" : "/pikolino-matrac-160x80-s-kokosom/",
    "/detsky-antialergicky-kokosovy-matrac-s-latexom-pikolino-180x80-2/" : "/detsky-antialergicky-kokosovy-matrac-s-latexom-pikolino-180x80/",
    "/detsky-antialergicky-kokosovy-matrac-s-latexom-pikolino-180x90/" : "/detsky-matrac-pikolino-180x90/",
    "/pikolino-kokosovo-latexovy-matrace-200x90/" : "/pikolino-kokosovo-priedusny-latexovy-matrace-200x90/",
    "/sofia-kokosovy-matrac-pre-deti-160x70-2/" : "/sofia-kokosovy-matrac-pre-deti-160x70/",
    "/sofia-detsky-kokosovy-matrac-180x80-2/" : "/sofia-detsky-kokosovy-matrac-180x80/",
    "/sofia-penovy-matrac-pre-deti-180x90-2/" : "/sofia-penovy-matrac-pre-deti-180x90/",
    "/sofia-matrac-pre-deti-so-studenou-penou-190x90/" : "/sofia-matac-pre-deti-so-studenou-penou-190x90/",
    "/matrac-s-kokosom-sandra-200x80/" : "/kokosovy-matrac-sandra-200x80/",
    "/matrac-s-kokosom-sandra-200x90/" : "/kokosovy-matrac-sandra-200x90/",
    "/matrac-s-kokosom-sandra-200x140/" : "/kokosovy-matrac-sandra-200x140/",
    "/matrac-s-kokosom-sandra-200x160/" : "/kokosovy-matrac-sandra-200x160/",
    "/matrac-s-kokosom-sandra-200x180/" : "/kokosovy-matrac-sandra-200x180/",
    "/matrac-s-kokosom-sandra-200x120/" : "/kokosovy-matrac-sandra-200x120/",
    "/gina-tastickovy-matrac-200x80/" : "/gina-matrac-s-tastickovymi-pruzinami-200x80/",
    "/gina-tastickovy-matrac-200x90/" : "/gina-matrac-s-tastickovymi-pruzinami-200x90/",
    "/tastickovy-matrac-s-kokosom-gina-200x120/" : "/matrac-s-tastickovymi-pruzinami-s-kokosom-gina-200x120/",
    "/tastickovy-matrac-s-kokosom-gina-200x140/" : "/matrac-s-tastickovymi-pruzinami-s-kokosom-gina-200x140/",
    "/tastickovy-matrac-s-kokosom-gina-200x160/" : "/matrac-s-tastickovymi-pruzinami-s-kokosom-gina-200x160/",
    "/matrac-s-kokosom-s-tastickami-gina-200x180/" : "/kokosovy-matrac-s-tastickovymi-pruzinami-gina-200x180/",
    "/detsky-matrac-bambino-candy-160x90-2/" : "/matrac-bambino-candy-160x90/",
    "/multifunkcna-poschodova-postel-party-14/" : "/multifunkcna-poschodova-postel-party-14-viac-farieb/",
    "/farebne-uchytky-pre-multifunkcne-poschodove-postele-party/" : "/uchytky-pre-multifunkcne-postele-party/",
    "/multifunkcna-poschodova-postel-toledo-1-viac-farieb/" : "/multifunkcna-postel-toledo-1/",
    "/uchyty-pre-multifunkcnu-postel-toledo/" : "/uchytky-pre-multifunkcnu-postel-toledo/",
    "/multifunkcna-poschodova-postel-toledo-2-viac-farieb/" : "/multifunkcna-postel-toledo-2-viac-farieb/",
    "/multifunkcna-oschodova-postel-max-3-rozne-farby/" : "/multifunkcna-poschodova-postel-max-3-viac-farieb/",
    "/detske-bavlnene-obliecky-100x135-40x60-mala-panda/" : "/detske-obliecky-mala-panda-100-135-40-60/",
    "/matrac-adriana-140x70/" : "/penovy-matrac-adriana-140x70/",
    "/matrac-bambino-console-kokos-pohanka-140x70/" : "/detsky-matrac-bambino-console-s-kokosom-140x70/",
    "/pikolino-detsky-priedusny-latexovy-matrac-140x70/" : "/pikolino-matrac-s-kokosom-a-latexom-140x70/",
    "/sofia-kokosovy-matrac-pre-deti-140x70/" : "/kokosovy-matrac-pre-deti-sofia-140x70/",
    "/paula-2-200x90-poschodova-postel-z-masivu-grafit/" : "/poschodova-postel-paula-2-200x90-grafit/",
    "/paula-2-200x90-poschodova-postel-z-masivu-biela/" : "/poschodova-postel-paula-2-200x90-biela/",
    "/detske-obliecky-nebi-120x90/" : "/detske-obliecky-nebi-120x90-2-dielne/",
    "/detske-obliecky-pegas-135x100/" : "/detske-obliecky-pegas-135x100-2-dielne/",
    "/bavlnene-obliecky-140x200-70x90-little-fairy/" : "/detske-bavlnene-obliecky-140x200-70x90-little-fairy-1/",
    "/bavlnene-obliecky-140x200-70x90-fireman-sam/" : "/detske-bavlnene-obliecky-140x200-70x90-fireman-sam/",
    "/pruzinovy-matrac-200x85/" : "/pruzinovy-matrac-85x200/",
    "/latovy-rost-90x200--120-kg-osoba/" : "/latovy-rost-90x200-120-kg-osoba/",
    "/lamelovy-rost-80x200--120kg-osoba/" : "/lamelovy-rost-80x200-120kg-osoba/",
    "/plachta-frote-120x60-2/" : "/plachta-frote-120x60/",
    "/plachta-frote-140x70-2/" : "/plachta-frote-140x70/",
    "/plachta-frote-160x70-2/" : "/plachta-frote-160x70/",
    "/plachta-frote-160x80-2/" : "/plachta-frote-160x80/",
    "/plachta-frote-180x80-2/" : "/plachta-frote-180x80/",
    "/plachta-frote-180x90-2/" : "/plachta-frote-180x90/",
    "/plachta-frote-190x80-2/" : "/plachta-frote-190x80/",
    "/plachta-frote-190x90-2/" : "/plachta-frote-190x90/",
    "/plachta-frote-200x80-2/" : "/plachta-frote-200x80/",
    "/plachta-frote-200x90-2/" : "/plachta-frote-200x90/",
    "/plachta-frote-200x100-2/" : "/plachta-frote-200x100/",
    "/plachta-jersey-160x70-2/" : "/plachta-jersey-160x70/",
    "/plachta-jersey-160x80-2/" : "/plachta-jersey-160x80/",
    "/plachta-jersey-180x80-2/" : "/plachta-jersey-180x80/",
    "/plachta-jersey-180x90-2/" : "/plachta-jersey-180x90/",
    "/plachta-jersey-190x80-2/" : "/plachta-jersey-190x80/",
    "/plachta-jersey-190x90-2/" : "/plachta-jersey-190x90/",
    "/plachta-jersey-200x80-2/" : "/plachta-jersey-200x80/",
    "/plachta-jersey-200x90-2/" : "/plachta-jersey-200x90/",
    "/plachta-jersey-200x100-2/" : "/plachta-jersey-200x100/",
    "/plachta-jersey-200x120-2/" : "/plachta-jersey-200x120/",
    "/plachta-jersey-200x200-2/" : "/plachta-jersey-200x200/",
  };
  var currentURL = window.location.href;
  var url = new URL(currentURL);
  var path = url.pathname;
  var newURL = "https://www.wilsondo.sk" + path;

  // Check if current URL exists in the list of keys in the object
  if (urlMapping.hasOwnProperty(path)) {
      newURL = "https://www.wilsondo.sk" + urlMapping[path];
  }
  // Create link and attach it before the add-to-card element
  var newLinkHTML = '<div class="external_linking_to_wsk"><a href="' + newURL +'?utm_source=poschodovky&utm_medium=referral&utm_campaign=external_linking">Kúpiť produkt na wilsondo.sk</a></div>';

  var addToCartElement = $('.p-info-wrapper .add-to-cart');
    if (addToCartElement.length) {
      addToCartElement.before(newLinkHTML);
  }
}

function disableSheetMixPurchase() {
  var urlMix;
  var urlSheets;
  var textSheets;
  switch(lang) {
    case 'sk':
      urlMix = '/celorocny-vankus-ecomax-2-ks/';
      urlSheets = '/vankuse/';
      textSheets = 'Pozrite si kompletnú ponuku vankúšov.';
      break;
    case 'hu':
      urlMix = '/ecomax-egeszeves-parna-2-ks/';
      urlSheets = '/parnak-es-kisparnak/';
      textSheets = 'Tekinsd meg teljes párna kínálatunkat.';
      break;
    default:
      return;
  }

  if (window.location.href.includes(urlMix)) {
    var addToCartButton = $('.p-info-wrapper .add-to-cart');
    var newLinkHTML = '<div class="gift_internal_link"><a href="'+ urlSheets +'">' + textSheets + '</a></div>';

    if (addToCartButton.length) {
      addToCartButton.hide();
      addToCartButton.before(newLinkHTML);
    }
  }
}

function addMOCLabel() {
  var labelText, tooltipText, prefixText;

  switch (lang) {
    case 'sk':
      labelText = "MOC";
      tooltipText = "Toto je výrobcom doporučená maloobchodná cena.";
      prefixText = "od ";
      break;
    case 'hu':
      labelText = "kisker ár";
      tooltipText = "Ez a gyártó által ajánlott kiskereskedelmi ár.";
      prefixText = "-tól";
      break;
    case 'cs':
      labelText = "MOC";
      tooltipText = "Toto je výrobcem doporučená maloobchodní cena.";
      prefixText = "od ";
      break;
    case 'ro':
      labelText = "PRP";
      tooltipText = "Acesta este prețul recomandat de vânzare cu amănuntul de către producător.";
      prefixText = "de la ";
      break;
    default:
      return;
  }

  const $priceContainer = $(".p-info-wrapper .p-short-description-block");
  if (!$priceContainer.length) return $(".moc-label").remove();

  const $wMocPrice = $priceContainer.find(".w-moc-price");
  if ($wMocPrice.length === 0 || $wMocPrice.find("span").length === 0) {
    return $(".moc-label").remove();
  }

  const $selects = $("select.hidden-split-parameter");
  let noVariantSelected = false;

  $selects.each(function () {
    const selected = $(this).find("option:selected").data("index");
    if (selected === 0 || selected === "0") {
      noVariantSelected = true;
    }
  });

  let mocPrice = "";

  function getLowestPrice() {
    let lowest = null;
    let priceText = "";

    $wMocPrice.find("span").each(function () {
      const text = $(this).text().trim();
      const num = parseFloat(text.replace(/\s/g, "").replace(/[^\d,\.]/g, "").replace(",", "."));
      if (!isNaN(num) && (lowest === null || num < lowest)) {
        lowest = num;
        priceText = text;
      }
    });

    if (!priceText) return "";
    return lang === "hu" ? priceText + prefixText : prefixText + priceText;
  }

  if (noVariantSelected) {
    mocPrice = getLowestPrice();
  } else {
    const $visibleSKU = $(".parameter-dependent")
      .not(".no-display")
      .not(".noDisplay")
      .not(".default-variant");

    if ($visibleSKU.length) {
      const activeSKU = $visibleSKU.first().text().trim();
      const $price = $wMocPrice.find(`span[data-sku="${activeSKU}"]`);
      if ($price.length) {
        mocPrice = $price.text().trim();
      } else {
        // Variant selected without MOC
        return $(".moc-label").remove();
      }
    } else {
      mocPrice = getLowestPrice();
    }
  }

  // If no MOC, remove label
  if (!mocPrice) return $(".moc-label").remove();

  $(".moc-label").remove();

  $(".p-final-price-wrapper").each(function () {
    const $moc = $(`
      <div class="moc-label">
        <span class="moc-label-text">${labelText} </span>
        <span class="moc-price">${mocPrice}</span>
        <span class="moc-tooltip-icon">i
          <div class="tooltiptext">${tooltipText}</div>
        </span>
      </div>
    `);
    $moc.insertAfter($(this));
  });
}

function initYotpoReviews() {
  const shopInstanceIds = {
    wsk: { tab: '1089532', price: '1121293' },
    whu: { tab: '1129501', price: '1129502' },
    wcz: { tab: '1129488', price: '1129500' },
    wro: { tab: '1017619', price: '1129504' },
    jam: { tab: '1129507', price: '1129515' },
    mee: { tab: '1129538', price: '1129548' },
  };

  const shopIds = shopInstanceIds[shopName];
  if (!shopIds) return;

  const $tab = $('#ratingTab');
  if (!$tab.length) return;

  $tab.find('#ratingWrapper, .votes-wrap').hide();
  $tab.find('p[data-testid="textCommentNotice"]').hide();
  $('.stars-wrapper').hide();

  let productSku = $('.p-code span').not('.p-code-label').first().text().trim();
  if (!productSku) return;
  productSku = productSku.replace(/\//g, '_');

  $tab.append(
    `<div class="yotpo-widget-instance yotpo-tab-widget" data-yotpo-instance-id="${shopIds.tab}" data-yotpo-product-id="${productSku}"></div>`
  );

  const $priceBox = $('.p-final-price-wrapper');
  if ($priceBox.length) {
    $('<div class="yotpo-widget-instance yotpo-price-widget" ' +
      'style="display: none;" ' + // základný stav
      'data-yotpo-instance-id="' + shopIds.price + '" ' +
      'data-yotpo-product-id="' + productSku + '">' +
      '</div>').insertBefore($priceBox);
  }

  let tryCount = 0;
  const maxTries = 30;

  const pollInterval = setInterval(() => {
    const $count = $('.yotpo-sr-bottom-line-text');
    if ($count.length) {
      const text = $count.text().trim();
      const match = text.match(/\((\d+)\)/);
      const reviewCount = match ? parseInt(match[1], 10) : 0;

      if (reviewCount === 0) {
        $('li[data-testid="tabRating"]').hide();
        $('a[href="#ratingTab"].shp-tab-link').hide();
        $('.yotpo-bottom-line-scroll-panel').css('pointer-events', 'none');
        $('.yotpo-tab-widget').remove(); 
      } else {
        $('.yotpo-price-widget').css('display', 'flex');
      }

      clearInterval(pollInterval);
    }

    if (++tryCount >= maxTries) {
      clearInterval(pollInterval);
    }
  }, 300);

  // Scroll
  $(document).on('click', '.yotpo-bottom-line-scroll-panel', function (e) {
    e.preventDefault();

    const $ratingTabLink = $('a[href="#ratingTab"].shp-tab-link');
    const $ratingTab = $('#ratingTab');

    if ($ratingTabLink.length && $ratingTab.length) {
      if (!$ratingTab.is(':visible')) {
        $ratingTabLink.trigger('click');
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $ratingTab.offset().top
          }, 300);
        }, 200);
      } else {
        $('html, body').animate({
          scrollTop: $ratingTab.offset().top
        }, 300);
      }
    }
  });

  $('a[href="#ratingTab"].shp-tab-link').each(function () {
    const $link = $(this);
    const cleanedText = $link.text().replace(/\s*\([^)]*\)/g, '').trim();
    $link.text(cleanedText);
  });
}
